import { Col, Row } from "reactstrap";
import AdminPage from "../../components/admin/AdminPage";
import AdminUploadResource from "../../components/admin/AdminUploadResource";
import AdminResourceGallery from "../../components/admin/AdminResourceGallery";
import useAdminEntity from "../../hooks/useAdminEntity";
import { useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { getNearByPlaceDetailsEndpoint, updateNearByPlaceAvatarEndpoint } from "./services/nearByPlaceService";
import useCallApiAndLoad from "../../hooks/useCallApiAndLoad";
import LoadingCard from "../../components/LoadingCard";
import { NearByPlaceDetail } from "./models/nearByPlaceModel";

const ModelNearByPlaceUploadAvatar = () => {

  const { id: nearByPlaceId = '' } = useParams();

  const { isLoading, callEndpoint } = useCallApiAndLoad();
  const navigate = useNavigate();
  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  const [errorAlert, setErrorAlert] = useState<any>(null);

  const pageName = `Actualizar avatar de lugar cercano`;
  const pageParentName = `Inversiones`;
  const globalAlertOptions = {
    success: false,
    warning: true,
    onConfirm: () => setErrorAlert(null),
    title: 'Error',
    text: errorAlert || '',
  };
  const getNearByPlaceModel = useCallback(
    () =>
      getNearByPlaceDetailsEndpoint(
        nearByPlaceId,
        token,
      ),
    [nearByPlaceId, token],
  );

  const [nearByPlace] = useAdminEntity<NearByPlaceDetail>(
    getNearByPlaceModel,
    setErrorAlert,
  );

  const uploadNearByPlaceAvatar = useCallback(
    async (files: Array<any>) => {
      if (files.length < 0) return;

      const formData = new FormData();
      files.forEach((file) => formData.append('avatar', file));
      const { status } = await callEndpoint(
        updateNearByPlaceAvatarEndpoint(
          nearByPlaceId,
          formData,
          token,
        ),
      );

      if (status === 200) navigate(0);
    },
    [nearByPlaceId, callEndpoint, navigate, token],
  );

  if (!nearByPlace || isLoading)
    return <LoadingCard name={pageName} parent_name={pageParentName} />;

  return (
    <AdminPage
      name={pageName}
      parentName={pageParentName}
      globalAlertOptions={globalAlertOptions}
    >
      <Row>
        <Col>
          <AdminUploadResource
            handleUpload={uploadNearByPlaceAvatar}
            description={'Subir avatar'}
            maxFiles={1}
          />
        </Col>
        <Col>
          <AdminResourceGallery
            gallery={nearByPlace.avatar ? [nearByPlace.avatar] : []}
            description={'Avatar actual'}
          />
        </Col>
      </Row>
    </AdminPage>
  );
};

export default ModelNearByPlaceUploadAvatar;